import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Home, FileText, CalendarCheck, ClipboardList, Folder, ChevronRight, Users, Clock } from 'lucide-react';

const HrNav = ({ isHovered, styles, onToggle }) => {
     const [adminOpen, setAdminOpen] = useState(false);
     const [attendanceSummeryOpen, setAttendanceSummaryOpen] = useState(false);

     return (
          <>
               <NavLink to="/dashboard" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <Home size={20} />
                    {isHovered && <span>Dashboard</span>}
               </NavLink>
               <NavLink to="/employee-master" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <Users size={20} />
                    {isHovered && <span>Employees</span>}
               </NavLink>

               {/* Admin Dropdown */}
               <div>
                    <button
                         type="button"
                         style={{
                              ...styles.navItem,
                              background: 'none',
                              border: 'none',
                              width: '100%',
                              textAlign: 'left',
                              display: 'flex',
                              alignItems: 'center',
                              cursor: 'pointer',
                              padding: '8px 12px',
                              color: '#333',
                         }}
                         onClick={() => setAdminOpen(!adminOpen)}
                    >
                         <CalendarCheck size={20} />
                         {isHovered && (
                              <>
                                   <span style={{ marginLeft: 12 }}>Duty Roster</span>
                                   <ChevronRight
                                        size={18}
                                        style={{
                                             marginLeft: 'auto',
                                             transition: 'transform 0.2s',
                                             transform: adminOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                                        }}
                                   />
                              </>
                         )}
                    </button>
                    {adminOpen && isHovered && (
                         <div style={{ paddingLeft: 32 }}>
                              <NavLink
                                   to="/dutyroster"
                                   style={({ isActive }) => ({
                                        ...styles.navItem,
                                        ...(isActive ? styles.navItemActive : {}),
                                        fontSize: 14,
                                        padding: '6px 12px',
                                   })}
                              >
                                   <Folder size={16} />
                                   <span style={{ marginLeft: 8 }}>Duty Roster</span>
                              </NavLink>
                              <NavLink
                                   to="/dutyrosterbulk"
                                   style={({ isActive }) => ({
                                        ...styles.navItem,
                                        ...(isActive ? styles.navItemActive : {}),
                                        fontSize: 14,
                                        padding: '6px 12px',
                                   })}
                              >
                                   <Folder size={16} />
                                   <span style={{ marginLeft: 8 }}>Duty Roster Bulk</span>
                              </NavLink>
                              <NavLink
                                   to="/employee-attendance"
                                   style={({ isActive }) => ({
                                        ...styles.navItem,
                                        ...(isActive ? styles.navItemActive : {}),
                                        fontSize: 14,
                                        padding: '6px 12px',
                                   })}
                              >
                                   <ClipboardList size={16} />
                                   <span style={{ marginLeft: 8 }}>Employee Attendance</span>
                              </NavLink>
                         </div>
                    )}
               </div>

               {/* Attendance Summary Dropdown */}
               <div>
                    <button
                         type="button"
                         style={{
                              ...styles.navItem,
                              background: 'none',
                              border: 'none',
                              width: '100%',
                              textAlign: 'left',
                              display: 'flex',
                              alignItems: 'center',
                              cursor: 'pointer',
                              padding: '8px 12px',
                              color: '#333',
                         }}
                         onClick={() => setAttendanceSummaryOpen(!attendanceSummeryOpen)}
                    >
                         <CalendarCheck size={20} />
                         {isHovered && (
                              <>
                                   <span style={{ marginLeft: 12 }}>Attendance Summary</span>
                                   <ChevronRight
                                        size={18}
                                        style={{
                                             marginLeft: 'auto',
                                             transition: 'transform 0.2s',
                                             transform: attendanceSummeryOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                                        }}
                                   />
                              </>
                         )}
                    </button>
                    {attendanceSummeryOpen && isHovered && (
                         <div style={{ paddingLeft: 32 }}>
                              <NavLink
                                   to="/doctor-attendance-summary"
                                   style={({ isActive }) => ({
                                        ...styles.navItem,
                                        ...(isActive ? styles.navItemActive : {}),
                                        fontSize: 14,
                                        padding: '6px 12px',
                                   })}
                              >
                                   <Folder size={16} />
                                   <span style={{ marginLeft: 8 }}>Doctor Summary</span>
                              </NavLink>
                              <NavLink
                                   to="/employee-attendance-summary"
                                   style={({ isActive }) => ({
                                        ...styles.navItem,
                                        ...(isActive ? styles.navItemActive : {}),
                                        fontSize: 14,
                                        padding: '6px 12px',
                                   })}
                              >
                                   <Folder size={16} />
                                   <span style={{ marginLeft: 8 }}>Employee Summary</span>
                              </NavLink>
                              <NavLink
                                   to="/poojari-attendance-summary"
                                   style={({ isActive }) => ({
                                        ...styles.navItem,
                                        ...(isActive ? styles.navItemActive : {}),
                                        fontSize: 14,
                                        padding: '6px 12px',
                                   })}
                              >
                                   <ClipboardList size={16} />
                                   <span style={{ marginLeft: 8 }}>Poojari Summary</span>
                              </NavLink>
                         </div>
                    )}
               </div>

               <NavLink to="/hr-radiology-assessment" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <ClipboardList size={20} />
                    {isHovered && <span>Radiology Assessment - HR</span>}
               </NavLink>
               <NavLink to="/doctors-shift-master" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <Clock size={20} />
                    {isHovered && <span>Doctors Shift Master</span>}
               </NavLink>
               <NavLink to="/leave-management" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <FileText size={20} />
                    {isHovered && <span style={{ marginLeft: '12px' }}>Doctors Leaves</span>}
               </NavLink>
               <NavLink to="/leaves/requests" style={({ isActive }) => ({ ...styles.navItem, ...(isActive ? styles.navItemActive : {}) })}>
                    <Clock size={20} />
                    {isHovered && <span>Leave Applications</span>}
               </NavLink>
          </>
     );
};

export const hrNav = (isHovered, styles, onToggle) => {
     return <HrNav isHovered={isHovered} styles={styles} onToggle={onToggle} />;
};

export default HrNav;